/**
 * Fiskal Cloud Admin Archiving Usage API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * Contact: info@deutsche-fiskal.de
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { ErsUsageItemDTO } from './ers-usage-item-dto';


export interface ErsUsageDTO { 
    /**
     * Represents the internal id of the ERS
     */
    id?: string;
    /**
     * Date which can be ERS:   * activation date (archiveActivation)   * billable from (archiveBillable) 
     */
    from?: string;
    /**
     * Date which can be ERS: * activation date (archiveActivation) * billable from (archiveBillable) 
     */
    to?: string;
    /**
     * External ERS ID
     */
    ersSerialNumber?: string;
    /**
     * Optional identifier of ERS
     */
    ersIdentifier?: string;
    /**
     * Billing price category. Value \'0\' means standard price, value greater than 0 means increased price.
     */
    billingTier?: number;
    usage?: Array<ErsUsageItemDTO>;
}

export class ClsErsUsageDTO { 
    /**
     * Represents the internal id of the ERS
     */
    id?: string = undefined;
    /**
     * Date which can be ERS:   * activation date (archiveActivation)   * billable from (archiveBillable) 
     */
    from?: string = undefined;
    /**
     * Date which can be ERS: * activation date (archiveActivation) * billable from (archiveBillable) 
     */
    to?: string = undefined;
    /**
     * External ERS ID
     */
    ersSerialNumber?: string = undefined;
    /**
     * Optional identifier of ERS
     */
    ersIdentifier?: string = undefined;
    /**
     * Billing price category. Value \'0\' means standard price, value greater than 0 means increased price.
     */
    billingTier?: number = undefined;
    usage?: Array<ErsUsageItemDTO> = undefined;
}

